import React, { Component } from 'react'
import styled, { keyframes } from 'styled-components'
import { leftRightMargin, alignRow, isDisabled } from './checkBoxHelpers.js'
import {
	innerBoxShadow,
	outerBoxShadow
} from '../ProgressBar/progressHelpers.js'

const click = color => keyframes`${outerBoxShadow(color)}`

const StyledContainer = styled.div`
	${({ disabled }) => isDisabled(disabled)}
	display: flex;
	${({ rightText }) => alignRow(rightText)}
	align-items: center;
`

const StyledLabel = styled.p`
	font-weight: 400;
	${({ rightText }) => leftRightMargin(rightText)}
	color: ${({ theme, headingColor = theme.darkGrey }) => headingColor};
`

const StyledCheckBox = styled.div`
	width: 16px;
	height: 16px;
	${({ theme, borderColor = theme.darkGrey }) => innerBoxShadow(borderColor)};
	border-radius: 50px;
	display: flex;
	align-items: center;
	justify-content: center;
`

const StyledFill = styled.div`
	width: inherit;
	height: inherit;
	border-radius: 50px;
	background-color: ${({ checked, theme, fillColor = theme.darkGrey }) =>
		checked && fillColor};
	transition: all 0.3s;
`

const StyledClickAnimation = styled.div`
	animation: ${({ clicked, theme, fillColor = theme.darkGrey }) =>
			clicked && click(fillColor)}
		0.3s;
	width: inherit;
	height: inherit;
	position: absolute;
	border-radius: 50px;
`

class CheckBox extends Component {
	constructor(props) {
		super(props)
		this.state = {
			isChecked: this.props.checkState || false,
			clicked: false
		}
	}

	checkChange = () => {
		this.props.onClick();
		this.setState({ clicked: true }, () => {
			this.clickAnimation()
		})
	}

	clickAnimation = () =>
		setTimeout(() => this.setState({ clicked: false }), 300)

	render() {
		const { rightText = true, label, disabled, onClick, checkState, ...props } = this.props
		const { isChecked } = this.state
		return (
			<StyledContainer
				{...props}
				disabled={disabled}
				onClick={!disabled && this.checkChange}
				rightText={rightText}>
				<StyledCheckBox {...props} checked={isChecked}>
					<StyledFill {...props} checked={checkState} />
				</StyledCheckBox>
				<StyledLabel {...props} rightText={rightText}>
					{label}
				</StyledLabel>
			</StyledContainer>
		)
	}
}

export default CheckBox



// WEBPACK FOOTER //
// ./src/artzu-ui/src/CheckBox/index.js